<template>
	<div style="margin: 20px;">
		<el-row style="margin-left: 30px;">
			<el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:rgb(214, 70, 97);">
						<p>{{data.updateDate}}</p>
						<p>第0{{data.miningLv}}期</p>

					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:rgb(214, 70, 97);">
						<p>{{data.yuanbao.toFixed(2)?data.yuanbao.toFixed(2):0}}</p>
						<span style="font-size: 24upx;">
							<!-- ≈¥{{(data.bottomBasin/data.yuanbao).toFixed(2)}} -->
						</span>
						<p>贡献值(VV)</p>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:#ff992f;">
						<p>{{data.miningYuanbao}}</p>
						<p>贡献值(VV)总产量</p>
					</div>
				</div>
			</el-col>

			<el-col :span="6">
				<div class="justifyContent">
					<div></div>
					<div class="grid-content" style="background-color: blue;">
						<p>
							¥{{data.yuanbao==0 ? 0:(data.bottomBasin/data.yuanbao).toFixed(2)}}
						</p>
						<p>贡献值(VV)实时参考价</p>
					</div>
				</div>
			</el-col>

		</el-row>
		<el-row style="margin-left: 30px;">

			<el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:#ff992f;">
						<p>
							{{data.bottomBasinTotal?data.bottomBasinTotal:0}}{{"("+data.bottomBasin.toFixed(2)+")"}}
						</p>
						<p>底池总金额</p>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:#ff992f;">
						<p>{{data.lastRewardRate*100+"%"}}</p>
						<p>当前弹性值</p>
					</div>
				</div>
			</el-col>

			<el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:rgb(214, 70, 97);">
						<p>{{data.totalPower}}</p>
						<p>全网贡献</p>
					</div>
				</div>
			</el-col>

			<el-col :span="6">
				<div class="justifyContent">
					<div></div>
					<div class="grid-content" style="background-color: rgb(214, 70, 97);">
						<p>
							{{dataInfo.userSum}}
						</p>
						<p>用户总数</p>
					</div>
				</div>
			</el-col>


			<!-- <el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:rgb(214, 70, 97);">
						<p>{{data.bbInto}}</p>
						<p>消费券(DL)投入总量</p>
					</div>
				</div>
			</el-col> -->
		</el-row>

		<el-row style="margin-left: 30px;">
			<el-col :span="6">
				<div class="justifyContent">
					<div class="grid-content" style="background-color:blue">
						<p>{{data.sharePower}}</p>
						<p>链接贡献</p>
					</div>
				</div>
			</el-col>


			<el-col :span="6">
				<div class="justifyContent">
					<div></div>
					<div class="grid-content" style="background-color: rgb(214, 70, 97);">
						<p>
							{{dataInfo.todayAddUserSum}}
						</p>
						<p>今日新增用户数</p>
					</div>
				</div>
			</el-col>

			<el-col :span="6">
				<div class="justifyContent">
					<div></div>
					<div class="grid-content" style="background-color: rgb(214, 70, 97);">
						<p>
							{{dataInfo.usdtExtractSum}}
						</p>
						<p>余额提现总数</p>
					</div>
				</div>
			</el-col>

			<el-col :span="6">
				<div class="justifyContent">
					<div></div>
					<div class="grid-content" style="background-color: #ff992f;">
						<p>
							{{dataInfo.todayUsdtExtractSum}}
						</p>
						<p>余额今日提现总数</p>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row style="margin-left: 30px;">

			<el-col :span="6">
				<div class="justifyContent">
					<div></div>
					<div class="grid-content" style="background-color: #ff992f;">
						<p>￥{{dataInfo.goodsOrderToday?dataInfo.goodsOrderToday:0 | intToFloatfour | cutZero}}
						</p>
						<p>商城今日营业额</p>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="justifyContent">
					<div></div>
					<div class="grid-content" style="background-color: blue;">
						<p>￥{{dataInfo.goodsOrderYesterday?dataInfo.goodsOrderYesterday:0 | intToFloatfour | cutZero}}
						</p>
						<p>商城昨日营业额</p>
					</div>
				</div>
			</el-col>

		</el-row>

	</div>



</template>
<script>
	export default {
		data() {
			return {
				data: {},
				dataInfo: {}
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			getHomeDate() {
				this.$api.homeDate({
					miningId: 1
				}).then((res) => {
					if (res.state == 'success') {
						this.data = res.data
					}
				})
			},
			homePageStatisticsQuery() {
				this.$api.homePageStatisticsQuery({}).then((res) => {
					if (res.state == 'success') {
						this.dataInfo = res.data
					}
				})
			}
		},
		created() {
			this.getHomeDate()
			this.homePageStatisticsQuery()
		}
	};
</script>
<style>
	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
		text-align: center;
		color: white;
		font-size: 18px;
		font-weight: bold;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 100px;
		width: 200px;
	}

	.justifyContent {
		display: flex;
		/* justify-content: space-around; */
		align-items: center;
		margin-top: 20px;

	}
</style>
